import React from 'react'

import { Button } from 'reactstrap'

export default function PrimaryButton(props) {
  const { className, ...rest } = props
  const style = `ssf-btn-primary ${className}`
  return <Button {...rest}  className={style} />
}
